module.exports = __webpack_public_path__ + "img/Pelletlager.cda054f.webp";